import { Nullable } from '@/shared/types/app.types'
import { NotificationVariableResponse } from '@/modules/configurationModule/detail/notifications/models/common'
import { EnumResponse } from '@/api/services/common.dto'
import { NotificationTemplateType } from '@/modules/configurationModule/detail/notifications/models/notification-templates'

export interface NotificationTemplatesModalType extends EnumResponse {
    code: NotificationTemplateType
}

export interface NotificationTemplatesModalState {
    id: Nullable<number>
    active: boolean
    type: Nullable<NotificationTemplatesModalType>
    text: string
    title: string
    allowedVariables: Nullable<NotificationVariableResponse[]>
}
export const initialNotificationTemplatesModalState =
    (): NotificationTemplatesModalState => ({
        id: null,
        active: true,
        type: null,
        text: '',
        title: '',
        allowedVariables: null
    })
